import { defineComponent, h } from 'vue';

/** Single full-width block row (object headers, colspan-style content). */
export default defineComponent({
    name: 'pg2-full-row',
    render() {
        return (
            <div class="c-PropertyGrid2__fullRow">
                {this.$slots.default?.()}
            </div>
        );
    },
});
